{
  "(optional)": "(valinnainen)",
  "(required)": "(pakollinen)"
}
